import md5 from "js-md5";
import dayjs from "dayjs";

/**
 * 对象转url
 * @param {*} obj
 */
function urlEncode(obj) {
  return Object.entries(obj)
    .map((item) => item.join("="))
    .join("&");
}

/**
 * 按属性对对象排序
 * @param {*} obj
 */
function objSort(obj) {
  return Object.keys(obj)
    .sort()
    .reduce((prev, current) => {
      prev[current] = obj[current];
      return prev;
    }, {});
}

/**
 * 参数加密
 * @param {*} data
 */
function paramsEncrypt(data) {
  if (Object.prototype.toString.call(data) !== "[object Object]") {
    console.warn("参数data类型必须是对象");
    return "";
  }
  if (!data.timestamp) {
    console.warn("参数data必须得包含属性timestamp");
    return "";
  }

  const str =
    urlEncode(objSort(data)) + "&secret=1BA09530-F9E6-478D-9965-7EB31A59537E";
  return md5(md5(str));
}

/**
 * api增加签名
 * @param {*} config axios请求拦截器的config对象
 * @returns 处理后的config对象
 */
export function addSignature(config) {
  if (!config.params) {
    config.params = {};
  }
  // 时间戳
  config.params.timestamp = dayjs().unix();
  // 签名 合并参数中如果有重名参数，覆盖优先级为：额外参数>get中参数>post参数。
  const sn = paramsEncrypt({ ...config.params, ...config.data });
  config.params.sn = sn;
  return config;
}
